var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Context = function () {
  function Context(expect) {
    (0, _classCallCheck3.default)(this, Context);

    this.expect = expect;
    this.level = 0;
  }

  (0, _createClass3.default)(Context, [{
    key: "child",
    value: function child() {
      var child = Object.create(this);
      child.level++;
      return child;
    }
  }]);
  return Context;
}();

module.exports = Context;